import React, { useState } from 'react';
import { View, StyleSheet,ScrollView } from 'react-native';
import {Text} from 'react-native-paper';
import { useClient } from '../providers/ClientProvider';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { RootStackParams } from './Home';
import { useNav } from '../providers/NavProvider';
import { getObjectByPath } from '../services/Utils';
import { ISitee } from './ClientLanding';
import { useFocusEffect } from '@react-navigation/native';
import Header from './Header';
import ReportProvider from './Logs/ReportProvider';
//import { ScrollView } from 'react-native-gesture-handler';

type Props = NativeStackScreenProps<RootStackParams, "List">

const ReportLanding: React.FC<Props> = ({ route }) => {
    const { setCurrentClientShortURL, clientObj } = useClient();
    //const navigation = useNavigation<NativeStackNavigationProp<RootStackParams>>();
    const { sitesResp, setCurrentLeafObj, currentLeafObj } = useNav();
    const { clientName } = useClient();
    const [siteObj, setSiteObj] = React.useState<ISitee>(null);
    const [projectId, setProjectId] = useState(null);
    useFocusEffect(() => {
        if (siteObj) {
            setCurrentLeafObj(siteObj);
            console.log(siteObj);
            if (sitesResp) {
                const projectSite = findProjectParent(sitesResp, siteObj.id);
                if(projectSite && projectSite.path.split('-').length === 2)
                    {
                      siteObj.id && setProjectId(projectSite.id);
                      console.info(`ProjectID=${siteObj.id}`);
                    }
            }
            
        }
    });
    function findProjectParent(siteResp: any, siteId: string): any | null {
        function findParentById(site: any, id: string): any | null {
            if (!site.children) return null;
    
            for (const child of site.children) {
                if (child.id === id) return site; // Direct parent found
                const parent = findParentById(child, id);
                if (parent) return parent; // Recursively check parents
            }
            return null;
        }
    
        // Start from given site and move up until we reach project-level site
        let currentSite = siteResp;
        let parent = findParentById(siteResp, siteId);
    
        while (parent) {
            // If the parent is a project-level site (2 segments in path), return it
            if (parent.path.split("-").length === 2) {
                return parent;
            }
            // Move up the hierarchy
            currentSite = parent;
            parent = findParentById(siteResp, currentSite.id);
        }
    
        return null; // No project-level parent found
    }
    
    React.useEffect(() => {
        setCurrentClientShortURL(route.params.clientShortURL);
        if (sitesResp) {
            const tempsiteObj = getObjectByPath(decodeURIComponent(route.params.sitePath), sitesResp);
            // setCurrentLeafObj(tempsiteObj);
            setSiteObj(tempsiteObj);
            
        }
    }, [route && route.params && route.params.sitePath && route.params.sitePath, sitesResp]);
    return (
        <View>
            <View>
                <Header></Header>
            </View>
            {/* <ScrollView contentContainerStyle={{ flexGrow: 1 }}> */}
                <View style={styles.navWrapper}>
                {(siteObj && siteObj.title) &&
                        <View style={{ backgroundColor: '#102B27', width: "100%", padding: 10, alignItems: 'center' }}>
                            <Text variant='titleLarge' style={{ color: '#fff' }} >{siteObj.title}</Text>
                        </View>
                    }
                    <View style={styles.container}>
                        {(siteObj) && (projectId!=null) &&
                                <View>
                                    {
                                        <ReportProvider logTitle={siteObj.title} parentId={siteObj.parentId} projectId={projectId}/>
                                    }
                                </View>
                        }
                    </View>
                </View>
            {/* </ScrollView> */}
        </View>
    )
}

const styles = StyleSheet.create({
    navWrapper: { backgroundColor: '#fff', flex: 1 },
    container: {
        //flex: 1,
        //padding: 16,
        // gap: 20,
        // flexDirection: 'row',
        // flexWrap: 'wrap',
        //alignItems: 'center',
        // justifyContent: 'space-evenly',
        //paddingLeft: 10,
        //paddingRight: 10,
        //minHeight:650,
        //maxWidth:1300,
        //alignSelf:'center'
    },
    // reportContainer: {
    //     alignItems: 'center'
    // },
    // card: {
    //     minWidth: 300,
    //     marginVertical: 8
    // },
    // logTitle: {
    //     fontWeight: '900',
    //     color:'#FFFFFF',//#ffcf1a'
    // },
});

export default ReportLanding;